import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsSelectMultiChoice, ModalSelectElement, SelectMultiChoiceTypes } from './generic-modal.service';

import { FormsModule } from '@angular/forms';
import { AutoFocusDirective } from '../auto-focus/auto-focus.directive';

@Component({
    selector: 'ep-modal-select-multi-choice',
    templateUrl: './modal-select-multi-choice.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, AutoFocusDirective]
})
export class ModalSelectMultiChoiceComponent {
    public options: ModalSettingsSelectMultiChoice;
    public selectedElement: ModalSelectElement;
    public choiceType = SelectMultiChoiceTypes;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsSelectMultiChoice;
        this.selectedElement = this.options.selectedElement;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok() {
        if (this.options.multiChoiceType == SelectMultiChoiceTypes.CheckBoxes) {
            let selectedItems = this.options.elements.filter((e: any) => e.selected);
            this.modalState.modal.close(selectedItems);
        }
        else {
            this.modalState.modal.close(this.selectedElement);
        }
    }
}